import axios from "axios";
import { APIOverrides } from "../../../ApiOverrides";
import type { PlayerContactProps, PublicPlayerProps } from "../../../types";
import type { Contact } from "expo-contacts";

let AUTH_SVC_API = '';


export { ContactsApi, ContactsHelpers }

const ContactsApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
    },
    getPlayerByPhone: async(phone:string):Promise<PublicPlayerProps | undefined> => {
        try {
            console.log('getting playerby phone now!!!')
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/player/search/phone`, { phone });
            console.log(resp.data)
            return resp.data.player
        } catch (e) {
            console.log('WE HIT AN ERROR!!!!!')
            return undefined
        }
    },
    generatePlayerByPhone: async( phone:string, referral_code?:string ):Promise<{ player_id:string } | undefined> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/player/phone/authenticate`, { phone, silent:true, referral_code });
            return resp.data.player_id
        } catch (e) {
            return undefined
        }
    },
    getPlayerById: async(player_id:string):Promise<PublicPlayerProps | undefined> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/players/player/${player_id}`);
            return resp.data.player
        } catch (e) {
            return undefined
        }
    },
    compareContacts: async(player_contacts:PlayerContactProps[]):Promise<PlayerContactProps[]> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/contacts/compare`, { player_contacts });
            return resp.data.player_contacts
        } catch (e) {
            console.log(e)
            return []
        }
    }
}


const ContactsHelpers = {
    formatContactPhoneNumber: (contact:Contact):string | undefined => {
        if(!contact.phoneNumbers){ return undefined }
        let us_phone_numbers = contact.phoneNumbers.filter(p => p.countryCode?.toLowerCase() == 'us');
        if(us_phone_numbers.length == 0){ return undefined }
        //Ok, we have some US numbers!.  Lets format them
        let us_phone_number = us_phone_numbers.find(n => n.isPrimary);
        if(!us_phone_number){
            us_phone_number = us_phone_numbers.find(n => n.label?.toLowerCase() == 'mobile');
        }
        if(!us_phone_number){
            us_phone_number = us_phone_numbers[0]
        }
        if(!us_phone_number){ return undefined }
        if(!us_phone_number.digits){ return undefined }
        let split_num = us_phone_number.digits.split('+')
        //Now check the split for the number
        let number = ''
        if(split_num.length == 1){ if(split_num[0]){ number = split_num[0] } }
        if(split_num[1]){ number = split_num[1] }

        //If it is ten digits - lets add to array
        if(number.length == 11){
            //Drop the first 1
            number = number.substring(1);
        }
        if(number.length != 10){ return undefined }
        return number       
    }
}